import * as React from "react";
const SvgViewCarousel = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 7h4v10H2V7zm5 12h10V5H7v14zM18 7h4v10h-4V7z",
  fill: "currentColor"
}));
export default SvgViewCarousel;